import { useEffect, useState } from 'react';
import { useProjectData } from '../Hooks/useProjectData';
import { setApiBaseUrl } from './setApiBaseUrl';

export function useApiInit() {
  const { projectData } = useProjectData();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!projectData?.baseUrl) return;

    setApiBaseUrl(projectData.baseUrl);
    setReady(true);
  }, [projectData]);

  return ready;
}
